import { useQuery } from "@tanstack/react-query";
import { StatsDailyResponse } from "@townsy/contracts";
import { apiFetch } from "./client";
import { STATS_REFRESH_MS } from "./queries";

/** The town's daily series (last 30 UTC days) behind the statistics cards' trend bars. */
export const fetchStatsDaily = (): Promise<StatsDailyResponse> => apiFetch("/api/v1/stats/daily", { schema: StatsDailyResponse });

export const statsDailyKey = ["stats-daily"] as const;

/** Refetched with the overview (every 30 s) while the statistics are open: today's bar keeps counting. */
export function useStatsDailyQuery(open: boolean) {
  return useQuery({ queryKey: statsDailyKey, queryFn: fetchStatsDaily, enabled: open, refetchInterval: open ? STATS_REFRESH_MS : false, staleTime: 10_000 });
}
